module.exports = __webpack_public_path__ + "static/media/Self-Serving Bias - sarah-kilian-52jRtc2S_VE-unsplash.384afccf.jpg";